const configuredBase = import.meta.env.VITE_API_BASE_URL as string | undefined;
const API_BASE = configuredBase && !configuredBase.includes("127.0.0.1:3500")
  ? configuredBase.replace(/\/$/, "")
  : "/api";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
  }
}

interface Envelope<T> {
  data: T;
  traceId: string;
}

interface RequestOptions extends RequestInit {
  query?: Record<string, string | number | boolean | undefined | null>;
}

function buildUrl(path: string, query?: RequestOptions["query"]): string {
  const url = new URL(`${API_BASE}${path}`, window.location.origin);
  for (const [key, value] of Object.entries(query ?? {})) {
    if (value !== undefined && value !== null && value !== "") url.searchParams.set(key, String(value));
  }
  return url.toString();
}

export async function api<T>(path: string, options: RequestOptions = {}): Promise<T> {
  const token = localStorage.getItem("pmc350_token");
  const headers = new Headers(options.headers);
  if (token) headers.set("authorization", `Bearer ${token}`);
  if (options.body && !(options.body instanceof FormData)) headers.set("content-type", "application/json");
  const response = await fetch(buildUrl(path, options.query), { ...options, headers });
  if (response.status === 401) {
    localStorage.removeItem("pmc350_token");
    if (!window.location.pathname.startsWith("/login")) window.location.assign("/login");
  }
  const contentType = response.headers.get("content-type") ?? "";
  if (!response.ok) {
    const body = contentType.includes("json") ? await response.json() : null;
    throw new ApiError(
      response.status,
      body?.error?.code ?? "REQUEST_FAILED",
      body?.error?.message ?? `请求失败（${response.status}）`,
      body?.error?.details,
    );
  }
  if (!contentType.includes("json")) return await response.text() as T;
  const body = await response.json() as Envelope<T>;
  return body.data;
}

export function jsonBody(value: unknown): string {
  return JSON.stringify(value);
}

export async function downloadExport(id: string, fileName: string): Promise<void> {
  const token = localStorage.getItem("pmc350_token");
  const response = await fetch(buildUrl(`/exports/${id}/download`), {
    headers: token ? { authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) throw new ApiError(response.status, "DOWNLOAD_FAILED", "下载失败");
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
